import axios from 'axios';

const api_path = process.env.REACT_APP_API;

const adminToken = localStorage.getItem('adminToken');

const headers = {
  'Content-Type': 'application/json',
  Authorization: 'Bearer ' + adminToken,
};

export const adminErrorHandler = (err) => {
  if (err?.response?.status === 401) {
    window.location.replace('/admin');
  }
};

const AdminApi = {
  login: (data) => {
    return axios.post(`${api_path}/adminlogin`, data)
  },

  getUserList: (keyword) => {
    return axios
      .post(`${api_path}/admin/user`, keyword, { headers })
  },

  addUser: async (data) => {
    const response = await axios
      .post(`${api_path}/admin/user/create`, data, { headers })

    return response;
  },

  addCredits: async (data, id) => {
    const response = await axios
      .post(`${api_path}/admin/addcredits/${id}`, data, { headers })

    return response;
  },

  withdrawCredits: async (data, id) => {
    const response = await axios
      .post(`${api_path}/admin/withdrawcredits/${id}`, data, { headers })

    return response;
  },

  editUser: async (payload, id) => {
    const response = await axios
      .post(`${api_path}/admin/edituser/${id}`, payload, { headers })

    return response;
  },

  editMaxBet: async (payload, id) => {
    const response = await axios
      .post(`${api_path}/admin/editMaxbet`, payload, { headers })

    return response;
  },

  getDefaultMaxBet: async (payload, id) => {
    const response = await axios
      .get(`${api_path}/admin/getDefaultMaxBet`, { headers })

    return response;
  },

  setDefaultMaxBet: async (payload, id) => {
    const response = await axios
      .post(`${api_path}/admin/setDefaultMaxBet`, payload, { headers })

    return response;
  },

  getUserDetail: async (payload) => {
    const response = await axios
      .post(`${api_path}/admin/userdetail`, payload, { headers })

    return response;
  },

  lockUser: async (id) => {
    const payload = { isLocked: 'true' };
    const response = await axios
      .post(`${api_path}/admin/edituser/${id}`, payload, { headers })

    return response;
  },

  unlockUser: async (id) => {
    const payload = { isLocked: 'false' };
    const response = await axios
      .post(`${api_path}/admin/edituser/${id}`, payload, { headers })

    return response;
  },

  lockAllUser: async () => {
    const response = await axios
      .post(`${api_path}/admin/lockAllUser`, {}, { headers })

    return response;
  },

  unlockAllUser: async () => {
    const response = await axios
      .post(`${api_path}/admin/unlockAllUser`, {}, { headers })

    return response;
  },

  changePassword: async (data, id) => {
    const response = await axios
      .post(`${api_path}/admin/user/changepassword/${id}`, data, { headers })

    return response;
  },

  deleteUser: async (id) => {
    return axios
      .delete(`${api_path}/admin/user/${id}`, { headers })
  },

  setNewUserBonus: async (payload) => {
    const response = await axios
      .post(`${api_path}/admin/setNewUserBonus`, payload, { headers })

    return response;
  },

  addBank: async (data) => {
    const response = await axios
      .post(`${api_path}/admin/bank/create`, data, { headers })

    return response;
  },

  editBank: async (input, id) => {
    const payload = input;
    const response = await axios
      .post(`${api_path}/admin/editbank/${id}`, payload, { headers })

    return response;
  },

  getBankList: async (keyword) => {
    return axios
      .post(`${api_path}/admin/bank`, keyword, { headers })
  },

  lockBank: async (id) => {
    const payload = { isOpen: false };
    const response = await axios
      .post(`${api_path}/admin/editbank/${id}`, payload, { headers })
    return response;
  },

  unlockBank: async (id) => {
    const payload = { isOpen: true };
    const response = await axios
      .post(`${api_path}/admin/editbank/${id}`, payload, { headers })

    return response;
  },

  deleteBank: async (id) => {
    return axios
      .delete(`${api_path}/admin/bank/${id}`, { headers })
  },

  getTransactionList: async (filter) => {
    return axios
      .post(`${api_path}/admin/transaction`, filter, { headers })
  },

  getTransactionCount: async (filter) => {
    return axios
      .get(`${api_path}/admin/getTransactionCount`, { headers })
  },

  editTransaction: async (input, id) => {
    const payload = input;
    const response = await axios
      .post(`${api_path}/admin/edittransaction/${id}`, payload, { headers })

    return response;
  },

  cancelDeposit: async (input, id) => {
    const payload = input;
    const response = await axios
      .post(`${api_path}/admin/cancelDeposit/${id}`, payload, { headers })

    return response;
  },

  addHandicap: async (data) => {
    const response = await axios
      .post(`${api_path}/admin/handicap/create`, data, { headers })

    return response;
  },

  getHandicapList: async (filter) => {
    return axios
      .post(`${api_path}/admin/handicap`, filter, { headers })

  },

  announceHandicap: async (input, id) => {
    const payload = input;
    const response = await axios
      .post(`${api_path}/admin/announce/handicap/${id}`, payload, { headers })

    return response;
  },

  editHandicap: async (payload, id) => {
    const response = await axios
      .post(`${api_path}/admin/updatehandicap/${id}`, payload, { headers })

    return response;
  },

  lockHandicap: async (id) => {
    const payload = { is_active: false };
    const response = await axios
      .post(`${api_path}/admin/edithandicap/${id}`, payload, { headers })


    return response;
  },

  activateHandicap: async (id) => {
    const payload = { is_active: true };
    const response = await axios
      .post(`${api_path}/admin/edithandicap/${id}`, payload, { headers })


    return response;
  },

  closeHandicap: async (id) => {
    const payload = { is_open: false };
    const response = await axios
      .post(`${api_path}/admin/edithandicap/${id}`, payload, { headers })


    return response;
  },

  openHandicap: async (id) => {
    const payload = { is_open: true };
    const response = await axios
      .post(`${api_path}/admin/edithandicap/${id}`, payload, { headers })


    return response;
  },

  addStep: async (data) => {
    const response = await axios
      .post(`${api_path}/admin/step/create`, data, { headers })


    return response;
  },

  getStepList: async (filter) => {
    return axios
      .post(`${api_path}/admin/step`, filter, { headers })

  },

  lockStep: async (id) => {
    const payload = { is_active: false };
    const response = await axios
      .post(`${api_path}/admin/editstep/${id}`, payload, { headers })


    return response;
  },

  activateStep: async (id) => {
    const payload = { is_active: true };
    const response = await axios
      .post(`${api_path}/admin/editstep/${id}`, payload, { headers })


    return response;
  },

  closeStep: async (id) => {
    const payload = { is_open: false };
    const response = await axios
      .post(`${api_path}/admin/editstep/${id}`, payload, { headers })


    return response;
  },

  openStep: async (id) => {
    const payload = { is_open: true };
    const response = await axios
      .post(`${api_path}/admin/editstep/${id}`, payload, { headers })


    return response;
  },

  editStep: async (payload, id) => {
    const response = await axios
      .post(`${api_path}/admin/updatestep/${id}`, payload, { headers })


    return response;
  },

  announceStep: async (input, id) => {
    const payload = input;
    const response = await axios
      .post(`${api_path}/admin/announce/step`, payload, { headers })


    return response;
  },

  getBillList: async (filter) => {
    return axios
      .post(`${api_path}/admin/bill`, filter, { headers })

  },

  getBillDetail: async (id) => {
    return axios
      .post(`${api_path}/admin/billDetail`, { id }, { headers })

  },

  getSummary: async (filter) => {
    return axios
      .post(`${api_path}/admin/summary`, filter, { headers })

  },

  addAdmin: async (data) => {
    const response = await axios
      .post(`${api_path}/admin/admin/create`, data, { headers })

    return response;
  },

  getAdminList: (keyword) => {
    return axios
      .post(`${api_path}/admin/admin`, keyword, { headers })

  },

  getAdminDetail: async (payload) => {
    const response = await axios
      .post(`${api_path}/admin/admindetail`, payload, { headers })


    return response;
  },

  editAdmin: async (payload, id) => {
    const response = await axios
      .post(`${api_path}/admin/editadmin/${id}`, payload, { headers })


    return response;
  },

  changePasswordAdmin: async (data, id) => {
    const response = await axios
      .post(`${api_path}/admin/admin/changepassword/${id}`, data, { headers })


    return response;
  },

  lockAdmin: async (id) => {
    const payload = { isLocked: 'true' };
    const response = await axios
      .post(`${api_path}/admin/editadmin/${id}`, payload, { headers })


    return response;
  },

  unlockAdmin: async (id) => {
    const payload = { isLocked: 'false' };
    const response = await axios
      .post(`${api_path}/admin/editadmin/${id}`, payload, { headers })


    return response;
  },
};

export default AdminApi;
